module.exports = __webpack_public_path__ + "images/107_1024.jpg";